import React, {Component, Fragment} from 'react';

export default class AddToBoxForm extends Component {
    render() {
        return (
            <Fragment>
                {(window.ui_version == 2) ? (
                    <div className="flexbox middle">
                        <div className="custom-mr-16">
                            <span className="custom-mr-8">Количество:</span>
                            <input
                                className="short"
                                type="number"
                                min="1"
                                max={this.props.item.quantity}
                                value={this.state.quantity}
                                onChange={e => this.setQuantity(+e.target.value)}
                            />
                        </div>
                        <div className="custom-mr-16">
                            <select value={this.state.box} onChange={e => this.setBox(+e.target.value)}>
                                <option value={-1}>Новая коробка</option>
                                {this.props.boxes.map((box, i) => (
                                    <option key={i} value={i}>Коробка #{i + 1}</option>
                                ))}
                            </select>
                        </div>
                        <div className="custom-mr-16">
                            <a
                                href="#"
                                onClick={e => {
                                    e.preventDefault();
                                    this.submit();
                                }}
                            >
                            <i className="fas fa-long-arrow-alt-right custom-mr-8" />
                                Добавить
                            </a>
                        </div>
                        <div className="custom-mr-16">
                            <a
                                href="#"
                                onClick={e => {
                                    e.preventDefault();
                                    this.props.onCancel();
                                }}
                            >
                                <i className="fas fa-times custom-mr-8" />
                                Отмена
                            </a>
                        </div>
                    </div>
                ) : (
                    <ul className="menu-h">
                        <li>
                            Количество:
                            <input
                                className="short"
                                type="number"
                                min="1"
                                max={this.props.item.quantity}
                                value={this.state.quantity}
                                onChange={e => this.setQuantity(+e.target.value)}
                            />
                        </li>
                        <li>
                            <select value={this.state.box} onChange={e => this.setBox(+e.target.value)}>
                                <option value={-1}>Новая коробка</option>
                                {this.props.boxes.map((box, i) => (
                                    <option key={i} value={i}>Коробка #{i + 1}</option>
                                ))}
                            </select>
                        </li>
                        <li>
                            <a
                                href="#"
                                onClick={e => {
                                    e.preventDefault();
                                    this.submit();
                                }}
                            >
                                <i className="icon16 move" />
                                Добавить
                            </a>
                        </li>
                        <li>
                            <a
                                href="#"
                                onClick={e => {
                                    e.preventDefault();
                                    this.props.onCancel();
                                }}
                            >
                                <i className="icon16 no-bw" />
                                Отмена
                            </a>
                        </li>
                    </ul>
                )}
            </Fragment>

        );
    }

    constructor(props) {
        super(props);
        this.state = {
            quantity: props.item.quantity,
            box: -1
        };
    }

    setQuantity(quantity) {
        this.setState({
            quantity: Math.min(this.props.item.quantity, Math.max(1, quantity))
        });
    }

    setBox(box) {
        this.setState({
            box: box
        });
    }

    submit() {
        if (this.state.box === -1) {
            this.props.onAddBox(this.state.quantity);
        } else {
            this.props.onAddToBox(this.props.boxes[this.state.box], this.state.quantity);
        }
    }
}